// ============================================================
// ByOurConsent.com -- useWindowWidth hook
// Returns current window width, updates on resize
// Usage:
//   const width = useWindowWidth();
//   const isMobile = width < 768;
// ============================================================

import { useState, useEffect } from 'react';

const useWindowWidth = () => {
    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1200
    );

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return width;
};

export default useWindowWidth;
